const translations = {
    success: {
        loaded: 'Cargado correctamente'
    },
    error: {},
    warning: {},
    info: {}
};

export default translations;
